<template>
  <el-card style="width: 100%;">
    <h2 class="xpqd">商品添加</h2>
    <page-wrap :style="pageClass">
    <el-form label-width="100px" size="mini" @submit.native.prevent>
      <el-form-item label="商品名称" required label-width="100px">
        <el-input v-model="formPost.g_name" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="商品分类" required label-width="100px">
        <el-row>
          <el-col :span="3">
            <el-input class="spfl" placeholder="请选择分类" v-model="c_name" readonly>
            </el-input>
          </el-col>
          <el-col :offset="1" :span="4">
            <el-button class="el-mini" type="info" icon="el-icon-search" @click="handle_ca = true">点击选择分类</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="商品简介" label-width="100px">
        <el-input v-model="formPost.g_profile"></el-input>
      </el-form-item>
      <el-form-item label="商品价格" required label-width="100px">
        <el-input v-model="formPost.price"></el-input>
      </el-form-item>
      <el-form-item label="起订量" required label-width="100px">
        <el-input v-model="formPost.g_moq"></el-input>
      </el-form-item>
      <el-form-item label="商品封面" required label-width="100px">
        <el-upload
          name="cover_img"
          action="/index.php/goods/Goods/upload/"
          list-type="picture-card"
          :file-list="fileList"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :limit="9"
          :on-exceed="handleExceed"
          :on-success="handleUploadSuccess"
          :multiple="true"
          style="margin-left: 3px"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip" style="margin-left: 20px">
            封面图两两之间不可重复，水印不可遮盖图片，且不能与详情中的图片重复。按ctrl键可多选图片
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="品牌ID:" label-width="100px" v-if="brand_id_list.length >0">
        <el-select v-model="formPost.brand_id" placeholder="请选择" @change="brandIdChange">
          <el-option
                  v-for="item in brand_id_list"
                  :key="item"
                  :label="item.brand_code"
                  :value="item.brand_code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品品牌" label-width="100px">
        <el-input v-model="formPost.brand" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="名片位置" label-width="100px">
        <el-input v-model="formPost.mp_rank"></el-input>
      </el-form-item>
    </el-form>
    <el-form label-width="100px" size="mini" @submit.native.prevent>
      <el-form-item label="关键词" label-width="100px" class="mr20">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags_kw"
          closable
          :disable-transitions="false"
          @close="handleCloseKw(tag)">
          {{tag}}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible_kw"
          v-model="inputValue_kw"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirmKw"
          @blur="handleInputConfirmKw"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInputKw">+关键词</el-button>
      </el-form-item>
    </el-form>
    <el-form label-width="100px" size="mini" @submit.native.prevent>
      <el-form-item label="投放地域:" label-width="100px" class="mr20">
        <el-tag
          :key="tag"
          v-for="tag in formPost.sellingLocation"
          closable
          :disable-transitions="false"
          @close="handleCloseSl(tag)">
          {{tag}}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible_sl"
          v-model="inputValue_sl"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirmSl"
          @blur="handleInputConfirmSl"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInputSl">+地域</el-button>
      </el-form-item>
    </el-form>
    <el-form label-width="100px" size="mini" @submit.native.prevent>
      <el-form-item label="详细参数" label-width="100px" class="mr20">
        <el-tag
          class="pl20"
          :key="tag"
          v-for="tag in dynamicTags_meta"
          closable
          :disable-transitions="false"
          @click="editParam(tag)"
          @close="handleCloseMeta(tag)">
          {{tag}}
        </el-tag>
        <div class="float-input">
          <el-input
            class="input-new-tag"
            v-if="inputVisible_meta"
            v-model="inputValue_meta1"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirmMeta"
            placeholder="参数名"
          ></el-input>
          <el-input
            class="input-new-tag"
            v-if="inputVisible_meta"
            v-model="inputValue_meta2"
            size="small"
            @keyup.enter.native="handleInputConfirmMeta"
            @blur="handleInputConfirmMeta"
            placeholder="参数值"
          ></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInputMeta">+详细参数</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-form label-width="100px" size="mini" @submit.native.prevent>
      <el-form-item label="附加批发价" label-width="100px" class="mr20">
        <el-tag
          class="pl20"
          :key="tag"
          v-for="tag in dynamicTags_more"
          closable
          :disable-transitions="false"
          @click="editParamMore(tag)"
          @close="handleCloseMore(tag)">
          {{tag}}
        </el-tag>
        <div class="float-input">
          <el-input
            class="input-new-tag"
            v-if="inputVisible_more"
            v-model="inputValue_more1"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirmMore"
            placeholder="起订量"
          ></el-input>
          <el-input
            class="input-new-tag"
            v-if="inputVisible_more"
            v-model="inputValue_more2"
            size="small"
            @keyup.enter.native="handleInputConfirmMore"
            @blur="handleInputConfirmMore"
            placeholder="价格"
          ></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInputMore">+详细参数</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-form label-width="100px" size="mini">
      <el-form-item label="商品详情" required label-width="100px">
        <ueditor
          class="html_text"
          keyId="editor_goods_add"
          @getUeMsg="syncContent"
        />
      </el-form-item>
    </el-form>
    <el-form label-width="100px" size="mini">
      <el-form-item label="商品视频" label-width="100px">
        <el-upload
                   :action="videoAction"
                   :on-remove="handleRemoveVideo"
                   :file-list="fileListVideo"
                   :before-upload="beforeVideoUpload"
                   :on-success="uploadVideo">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传avi/mp4/wmv/mov文件，且不超过10M</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-form style="height: 200px;margin-left: 200px;padding-top: 50px">
      <el-form-item>
        <el-button @click="close()" title="取消">取 消</el-button>
        <el-button type="primary" @click="handleConfirm()" title="确定提交">确 定</el-button>
        <el-button type="primary" @click="submitInfos">检测敏感词</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <Category :handle="handle_ca" @closeSelf="closeCategory" @confirm="callbackCat"/>
    </page-wrap>
  </el-card>
</template>
<style>
  .el-tag + .el-tag {
    margin-left: 10px;
    margin-bottom: 2px;
  }

  .float-input {
    float: left;
  }

  .float-input input {
    float: left;
  }

  .float-input .el-input {
    width: 30%;
  }
  #edui1_iframeholder {width: 100%!important;}
</style>
<script>
  import Ueditor from './../../components/base/Ueditor'
  import Category from '../../components/dialog/Category'

  export default {
    components: {
      Ueditor, Category
    },
    props: {},
    watch: {},
    data() {
      return {
        c_id: 0,
        c_name: '',
        handle_ca: false,
        formPost: {
          g_name: "", c_id: "", g_profile: "", price: "", g_moq: '1件', fileList: [], g_detail: "", kw: '',brand_id:"",
          brand: '', meta: [], mp_rank: '', g_video: '', g_video_uri: '', g_moq_more: [],  sellingLocation: [],
        },
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        dynamicTags_kw: [],
        dynamicTags_meta: [],
        inputVisible_kw: false,
        inputVisible_sl: false,
        inputVisible_meta: false,
        inputValue_kw: '',
        inputValue_sl: '',
        inputValue_meta1: '',
        inputValue_meta2: '',
        fileListVideo: [],
        videoAction: this.$work_host + "/index.php/common/Upload/video?b_id=" + localStorage.getItem("org_b_id"),
        //2020/4/17
        dynamicTags_more: [],
        inputVisible_more: false,
        inputValue_more1: '',
        inputValue_more2: '',
        pageClass:{overflow:"auto",height:"900px"},
        brand_id_list: [],
      }
    },
    mounted() {
        this.pageClass.height = document.getElementsByClassName('el-menu')[0].offsetHeight + "px";
        this.$ajax.get(this.$work_host +"/index.php/admin/login/getBusinessBrandList?b_id="+localStorage.getItem("org_b_id")).then(res =>{
            if(res.data.error === 0){
                this.brand_id_list = res.data.data;
            }
        }).catch(e=>{
            console.error(e)
        })
    },
    methods: {
        brandIdChange(val){
            this.brand_id_list.forEach(item=>{
                if(item.brand_id === val){
                    this.formPost.brand = item.brand_name;
                }
            })
        },
      beforeVideoUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error('大小不能超过 10M!');
        }
        return isLt2M;
      },
      handleRemoveVideo(file, nfileList) {
        console.log(file)
        this.formPost.g_video = '';
        this.formPost.g_video_uri = ""
      },
      uploadVideo(response, file, fileList) {
        if (response.error == 0) {
          this.fileListVideo = [{name: response.data.url, url: response.data.url}];
          this.formPost.g_video = response.data.url;
          this.formPost.g_video_uri = response.data.uri
        } else {
          this.$message.error('视频上传失败：' + response.message)
          this.fileListVideo = [];
        }
      },
      editParam(tag) {
        let a = tag.split(':')
        this.inputValue_meta1 = a[0]
        this.inputValue_meta2 = a[1]
        this.inputVisible_meta = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
        this.dynamicTags_meta.splice(this.dynamicTags_meta.indexOf(tag), 1);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除该图片？`);
      },
      handleRemove(file, fileList) {
        let img = file.response.data;
        this.formPost.fileList = arrayRemove(this.formPost.fileList, img)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 ${fileList.length} 张列表图`);
      },
      handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleUploadSuccess(response, file) {
        if (response.error === 0) {
          this.formPost.fileList.push(response.data);
        } else {
          this.$message.error(response.message)
        }
      },
      handleConfirm() {
        let that = this
        that.submitInfos();
        setTimeout(()=>{
          if (that.formPost.g_name != '' && that.formPost.g_name.indexOf("✎") != -1 ){
            that.$message.error("商品名称包含敏感词，请替换后在保存");
            return false;
          }
          if (that.formPost.g_profile != '' && that.formPost.g_profile.indexOf("✎") != -1 ){
            that.$message.error("商品简介包含敏感词，请替换后在保存");
            return false;
          }
          if (that.formPost.g_detail != '' && that.formPost.g_detail.indexOf("✎") != -1 ){
            that.$message.error("商品详情包含敏感词，请替换后在保存");
            return false;
          }
          this.formPost.kw = this.dynamicTags_kw
          this.formPost.meta = this.dynamicTags_meta
          this.formPost.g_moq_more = this.dynamicTags_more
          this.$ajax.post('goods/Goods/add', that.formPost).then(function (res) {
            console.log(res.data)
            if (res.data.error === 0) {
              that.close()
            } else {
              that.$message(res.data.message)
            }
          })
        },500)

      },
      submitInfos() {
        let that = this;
        this.$ajax.post('goods/Goods/detection', that.formPost).then(function (res) {
          that.insertedMsg = {insertMsgBool: !that.insertedMsg.insertMsgBool, msg: res.data.data.g_detail};
          that.formPost = res.data.data
        })
      },
      close() {
        this.$router.push("/index/goods/Index")
      },
      callbackCat(data) {
        this.handle_ca = false;
        this.c_id = data.last_value;
        this.formPost.c_id = data.last_value;
        this.c_name = data.last_label;
      },
      closeCategory() {
        this.handle_ca = false;
      },
      syncContent(data) {
        this.formPost.g_detail = data;
      },

      handleCloseKw(tag) {
        this.dynamicTags_kw.splice(this.dynamicTags_kw.indexOf(tag), 1);
      },

      handleCloseSl(tag) {
        this.formPost.sellingLocation.splice(this.formPost.sellingLocation.indexOf(tag), 1);
      },

      handleCloseMeta(tag) {
        this.dynamicTags_meta.splice(this.dynamicTags_meta.indexOf(tag), 1);
      },

      showInputKw() {
        this.inputVisible_kw = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      showInputSl() {
        if (this.formPost.sellingLocation.length >= 20) {
          this.$message({
            type: "error",
            message: "最多只能添加20个投放地域!"
          });
          return;
        }
        this.inputVisible_sl = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      showInputMeta() {
        this.inputVisible_meta = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirmKw() {
        let inputValue = this.inputValue_kw;
        if (inputValue) {
          this.dynamicTags_kw.push(inputValue);
        }
        this.inputVisible_kw = false;
        this.inputValue_kw = '';
      },

      handleInputConfirmSl() {
        let inputValue = this.inputValue_sl;
        if (inputValue) {
          this.formPost.sellingLocation.push(inputValue);
        }
        this.inputVisible_sl = false;
        this.inputValue_sl = '';
      },

      handleInputConfirmMeta() {
        let inputValue = this.inputValue_meta1 + ":" + this.inputValue_meta2;
        if (this.inputValue_meta1 !== '' && this.inputValue_meta2 !== "") {
          this.dynamicTags_meta.push(inputValue);
        }
        this.inputVisible_meta = false;
        this.inputValue_meta1 = '';
        this.inputValue_meta2 = '';
      },

      //2020-4-17
      editParamMore(tag) {
        let a = tag.split(':')
        this.inputValue_more1 = a[0]
        this.inputValue_more2 = a[1]
        this.inputVisible_more = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
        this.dynamicTags_more.splice(this.dynamicTags_more.indexOf(tag), 1);
      },
      showInputMore() {
        if (this.dynamicTags_more.length > 4) {
          this.$message({
            type: "error",
            message: "最多只能添加五组批发价!"
          });
        } else {
          this.inputVisible_more = true;
          this.$nextTick(() => {
            this.$refs.saveTagInput.$refs.input.focus();
          });
        }

      },
      handleInputConfirmMore() {
        let inputValue = this.inputValue_more1 + ":" + this.inputValue_more2;
        if (this.inputValue_more1 !== '' && this.inputValue_more2 !== "") {
          this.dynamicTags_more.push(inputValue);
        }
        this.inputVisible_more = false;
        this.inputValue_more1 = '';
        this.inputValue_more2 = '';
      },
      handleCloseMore(tag) {
        this.dynamicTags_more.splice(this.dynamicTags_more.indexOf(tag), 1);
      },
    }
  }

  function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele != value;
    });
  }
</script>



// WEBPACK FOOTER //
// src/views/goods/Add.vue